import AutoQuery from 'servicestack/auto-query/auto-query'
import ServiceBus from 'servicestack/service-bus'
import BasicController from 'servicestack/basic.controller'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import templateUrl from 'emun.vendor/vendor-contact-prompt.htm'
import VendorContactPromptController from 'emun.vendor/vendor-contact-prompt.controller'


const VendorContactPromptFactory= {
    open(options) {
        return modals.open(angular.extend({
            templateUrl,
            resolve: {
                options: () => options
            },
            controller: VendorContactPromptController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};

function VendorContactPromptDirective($window, $parse, $session) {
    // Introduce custom elements for IE8
    $window.document.createElement('vendor-contact-prompt');
    return {
        scope: false,
        link: function (scope, element, attr) {
            var onVendorContactCreated = attr.onVendorContactCreated || attr.onVendorContactSaved;

            var $targets = (attr.vendorContactPromptClickSelector ? element.find(attr.vendorContactPromptClickSelector) : element);
            $targets.on('click', e => {
                var model = scope.$eval(attr.vendorContactPrompt || attr.ngModel || attr.vendor || attr.contact) || {
                    vendor: attr.vendor,
                    contact: attr.contact
                };
                if (!model.contact) {
                    var date = new Date();
                    model.contact = {
                        vendorId: model.vendor.id,
                        createdBy: $session.userAuthName,
                        username: $session.userAuthName
                    }
                }
                VendorContactPromptFactory.open({ title: attr.title, scope, attr, element, $targets, model }).then(
                    (saved) => {
                        if (attr.onVendorContactSaved) {
                            $parse(attr.onVendorContactSaved)(scope, { $saved: saved })
                        }
                    }, () => {
                        if (attr.onDismissed) {
                            $parse(attr.onDismissed)(scope, {})
                        }
                    });
            });
        }
    }
};

export default VendorContactPromptDirective;